import {
    FiClipboard, FiSun, FiClock, FiMap, FiWifi, FiTrello,
    FiCheckSquare, FiShield, FiMonitor, FiSend, FiBookOpen, FiStar, FiGrid, FiActivity, FiLayers,
    FiTarget, FiFileText,
    // [F-8 2026-09-11] Sejf haseł działu.
    FiLock,
} from "react-icons/fi";

/**
 * JEDNO ŹRÓDŁO PRAWDY zakładek modułu „Mój Dział".
 * Używane przez: hub (MyDeptHubPage — wewnętrzna nawigacja) ORAZ dropdown w Sidebarze.
 * `id` == ostatni segment trasy PL (routes.js) → na nim opiera się wykrywanie aktywnej zakładki.
 * `route` == klucz w routes.js (localizedPath). `Icon` == komponent react-icons (renderowany per konsument).
 *
 * [BRIEF 2026-08-30 pkt 2 — „za ciężki UX"] BYŁO ŹLE: 15 równorzędnych zakładek w czterech grupach
 * technicznych („Przegląd / Kadry / Narzędzia / Zarządzanie"), renderowanych RÓWNOLEGLE w trzech
 * miejscach (przewijalny pasek, dropdown „Wszystkie", lista w Sidebarze). Nagłówek chwalił się przy
 * tym licznikiem „Moduły: 15", czyli reklamował własną złożoność. Dwie pary nazw znaczyły co innego
 * niż wyglądały: „Czas pracy" tutaj to analityka aktywności O365, a „Mój czas pracy" w innym module
 * to grafik i urlopy; „Uprawnienia" nie pokazywały uprawnień aplikacji, tylko dyski sieciowe.
 * NAPRAWA: te same 15 tras (żadnego martwego linku, sidebar i zakładki bez zmian w kontrakcie),
 * ale pogrupowane w SZEŚĆ sekcji odpowiadających pytaniom przełożonego. Hub renderuje sześć
 * przycisków najwyższego poziomu i — dopiero w wybranej sekcji — jej podzakładki. Nazwy mylące
 * zostały doprecyzowane („Aktywność O365", „Dostępy", „Tablica").
 *
 * [PAKIET 2026-09-02] Opcjonalne pole `permission` — klucz, BEZ którego zakładki nie ma.
 * BYŁO ŹLE: `MY_DEPT_TABS` nie miało takiego pola, więc hub i dropdown w Sidebarze renderowały
 * KOMPLET zakładek każdemu, kto ma `ModuleMojDzial`. Dla dwunastu zakładek to działało (wszystkie
 * stoją na tym samym kluczu i na zasięgu hierarchii liczonym po stronie API), ale „Dokumenty"
 * wchodzą na osobnym kluczu `DeptDocsView`: bez filtru kierownik bez nadania widziałby zakładkę,
 * klikał i dostawał ekran odmowy. Menu ma prowadzić tam, gdzie realnie wpuszcza.
 * Pole czytają DWA miejsca i oba muszą je czytać: `MyDeptHubPage` (pasek sekcji i podzakładek)
 * oraz `Sidebar.js` (dropdown „Mój Dział"). Brak pola = zakładka dla każdego z `ModuleMojDzial`.
 */
export const MY_DEPT_GROUPS = {
    przeglad: { label: "Pulpit", color: "#6366F1" },
    wnioski: { label: "Wnioski", color: "#6366F1" },
    czas: { label: "Czas pracy", color: "#0EA5E9" },
    zespol: { label: "Zespół", color: "#10B981" },
    rozwoj: { label: "Rozwój", color: "#8B5CF6" },
    zadania: { label: "Zadania", color: "#F59E0B" },
};

/** Kolejność sekcji w pasku hubu (klucze MY_DEPT_GROUPS). */
export const MY_DEPT_GROUP_ORDER = ["przeglad", "wnioski", "czas", "zespol", "rozwoj", "zadania"];

export const MY_DEPT_TABS = [
    { id: "pulpit", label: "Pulpit", icon: FiGrid, route: "myDeptOverview", group: "przeglad" },

    // Wnioski: „co czeka na moją decyzję" + „co mam wypełnić i o czym pamiętać" (zlecenia HR, umowy).
    { id: "wnioski", label: "Wnioski", icon: FiClipboard, route: "myDeptRequests", group: "wnioski" },
    { id: "wnioski-przelozonego", label: "Moje do wypełnienia", icon: FiSend, route: "myDeptManagerReqs", group: "wnioski" },

    // Czas pracy zespołu — jeden kalendarz widziany z czterech stron.
    { id: "grafik", label: "Grafik", icon: FiClock, route: "myDeptSchedule", group: "czas" },
    // Ujednolicone urlopy: jedna zakładka „Urlopy" oparta na działającym widoku planu urlopów
    // (dawny duplikat „Urlopy"=MyDeptLeavePage był zepsuty — zły model danych + błędne sygnatury API).
    { id: "urlopy", label: "Urlopy", icon: FiSun, route: "myDeptLeave", group: "czas" },
    { id: "praca-zdalna", label: "Praca zdalna", icon: FiWifi, route: "myDeptRemote", group: "czas" },
    // Etykieta doprecyzowana: to NIE jest grafik, tylko analityka aktywności z Office 365.
    { id: "czas-pracy", label: "Aktywność O365", icon: FiActivity, route: "myDeptWorkTime", group: "czas" },

    // Zespół — kto u mnie jest i co ma na stanie.
    { id: "struktura", label: "Struktura", icon: FiMap, route: "myDeptStructure", group: "zespol" },
    { id: "wyposazenie", label: "Wyposażenie IT", icon: FiMonitor, route: "myDeptEquipment", group: "zespol" },
    // [F-8 2026-09-11] Sejf haseł działu. Bez `permission`: zakładki dobiera PRZYNALEŻNOŚĆ
    // do działu (serwer), a nie klucz — „przełożony przełożonego nie widzi zakładki działu".
    { id: "sejf", label: "Sejf haseł", icon: FiLock, route: "myDeptSejf", group: "zespol" },
    // Etykieta doprecyzowana: zakładka odpowiada na pytanie „do czego mój zespół ma dostęp".
    { id: "uprawnienia", label: "Dostępy", icon: FiShield, route: "myDeptPermissions", group: "zespol" },
    // [PAKIET 2026-09-02, moduł K] Pisma wydawane przez dział ze wzorów przypisanych temu działowi.
    // Jedyna zakładka hubu z własnym kluczem — patrz nagłówek pliku.
    // [polecenie właściciela 2026-09-29] „dokumenty działu jako dyrektor, kierownik — zarządzanie i przypisywanie w zakresie dokumentacji”:
    // zakładka otwiera się także REALNEMU przełożonemu bez DeptDocsView (klucz DepartmentManagerAccess, auto z funkcji w strukturze) —
    // widzi wtedy podzakładkę „Procedury i instrukcje”; rejestr wydań i wzory dalej wymagają DeptDocsView (serwer i strona to rozstrzygają).
    { id: "dokumenty", label: "Dokumenty", icon: FiFileText, route: "myDeptDocuments", group: "zespol", permission: ["DeptDocsView", "DepartmentManagerAccess"] },
    // [polecenie właściciela 2026-09-30] „/polityki (…) ma być w Mój Dział, dostępna dla wprowadzenia i przygotowania przez pracownika,
    // odpowiedzialność spływa na dyrektora” — zakładka bez `permission`: pracownik przygotowuje szkic procedury swojego działu,
    // kierownik nią zarządza i przypisuje (serwer: GET /api/polityki/dzial — tryb członka / kierowania).
    { id: "procedury", label: "Procedury", icon: FiLayers, route: "myDeptProcedury", group: "zespol" },

    // Rozwój — ocena wdrożeniowa (INS-ZKL-02) i szkolenia.
    { id: "ocena-pracownika", label: "Ocena i wdrożenie", icon: FiStar, route: "myDeptEvaluation", group: "rozwoj" },
    { id: "e-learning", label: "E-Learning", icon: FiBookOpen, route: "myDeptELearning", group: "rozwoj" },
    // [PAKIET 2026-09-02, moduł H] Cele zespołu: propozycje do akceptacji, postęp, ocena okresu.
    // Bez `permission` — stoi na `ModuleMojDzial` i hierarchii, jak reszta zakładek zespołowych.
    { id: "cele", label: "Cele", icon: FiTarget, route: "myDeptGoals", group: "rozwoj" },

    // Zadania — lista i tablica tego samego zespołu.
    { id: "todo", label: "Zadania", icon: FiCheckSquare, route: "myDeptTodo", group: "zadania" },
    { id: "kanban", label: "Tablica", icon: FiTrello, route: "myDeptKanban", group: "zadania" },
];

/**
 * [N-6, polecenie właściciela 2026-09-08] Zakładki dla przełożonego, który ma WYŁĄCZNIE działy raportujące do
 * niego (kierownik działu X raportuje do mnie, a sam mam inny dział albo żadnego): „zostaw tylko informację
 * o dziale, gdzie raportuje mi kierownik tego działu, w zakresie zakładek pulpit / wnioski / struktura. Pozostałe
 * zakładki dotyczą tylko przełożonych w danym dziale." Serwer liczy `hasOperationalScope` (GET /my-dept/scope);
 * ten filtr czytają DWA miejsca — pasek hubu i dropdown w Sidebarze — z jednego źródła.
 */
// [2026-09-30] + „procedury”: także przełożony bez zasięgu operacyjnego ma dział w strukturze — tryb członka (serwer liczy zakres).
export const MY_DEPT_TABS_TYLKO_RAPORTUJACY = ["pulpit", "wnioski", "struktura", "dokumenty", "procedury"];

/* [S-7, polecenie właściciela 2026-09-09] „jak jestem w moj-dzial tylko przełożonym danego dyrektora, to włącz też widok dla
   dokumentów, by dyrektor przełożonego mógł je akceptować (…) ale tylko ta zakładka w zakresie". Zakładka „Dokumenty" dochodzi
   do trzech N-6 — lista wydań działu liczy zasięg WIDOCZNY działów (dział raportujący jest w nim), a decyzję i tak rozstrzyga
   ścieżka akceptacji wzoru (krok „przełożony wydającego"). Klucz `DeptDocsView` obowiązuje bez zmian. */

/* [J-5, polecenie właściciela 2026-09-09] „dla pracownika, który jest tylko przełożonym dyrektora, dodatkowo wyłącz grafik,
   urlopy, praca-zdalna, czas-pracy, wyposazenie, uprawnienia, ocena-pracownika, e-learning, todo, kanban — natomiast przywróć
   zakładkę dokumenty". Serwer (GET /my-dept/scope → `trybZakladek`) rozpoznaje tę osobę jedną regułą
   (AccessControlService.GetTrybMojDzialAsync): nie kieruje żadnym działem, a jej podwładni z kartoteki SAMI kierują
   (dyrektor / kierownik działu). ROOT CAUSE: N-6 liczył „ma zespół" jako „ktokolwiek poza mną", a rdzeń przełożonego
   materializuje dyrektora jako podwładnego — więc taka osoba dostawała komplet. Zostają: Pulpit, Wnioski, Moje do wypełnienia,
   Struktura, Dokumenty (klucz DeptDocsView nadawany z funkcji), Cele. */
export const TRYB_ZAKLADEK = { PELNY: "pelny", TYLKO_RAPORTUJACY: "tylko-raportujacy", PRZELOZONY_DYREKTORA: "przelozony-dyrektora" };
export const MY_DEPT_TABS_PRZELOZONY_DYREKTORA = ["pulpit", "wnioski", "wnioski-przelozonego", "struktura", "dokumenty", "procedury", "cele"];

/** Dozwolone identyfikatory zakładek dla trybu; `null` = wszystkie. Kod trybu z serwera ma pierwszeństwo przed flagą N-6. */
export const dozwoloneZakladki = (maZasiegOperacyjny, trybZakladek = null) => {
    if (trybZakladek === TRYB_ZAKLADEK.PRZELOZONY_DYREKTORA) return MY_DEPT_TABS_PRZELOZONY_DYREKTORA;
    if (trybZakladek === TRYB_ZAKLADEK.TYLKO_RAPORTUJACY) return MY_DEPT_TABS_TYLKO_RAPORTUJACY;
    if (trybZakladek == null && maZasiegOperacyjny === false) return MY_DEPT_TABS_TYLKO_RAPORTUJACY;
    return null;
};

/** Czy zakładka `id` należy do zestawu trybu — pilnuje także wejścia z adresu (hub trzyma jedną trasę „/moj-dzial/*"). */
export const zakladkaDozwolona = (id, maZasiegOperacyjny, trybZakladek = null) => {
    const lista = dozwoloneZakladki(maZasiegOperacyjny, trybZakladek);
    return lista == null || lista.includes(id);
};

/** Tryb z serwera / `maZasiegOperacyjny === false` → zawężony zestaw; `true`/nieznane → komplet (awaria zapytania nie chowa menu). */
export const filtrujZakladkiWgZasiegu = (tabs, maZasiegOperacyjny, trybZakladek = null) => {
    const lista = dozwoloneZakladki(maZasiegOperacyjny, trybZakladek);
    return lista == null ? tabs : tabs.filter((t) => lista.includes(t.id));
};

/* [O2, polecenie właściciela 2026-09-13] ZAKŁADKI PER DZIAŁ ODPOWIEDZIALNOŚCI. „jakbym był przełożonym przełożonych z 2 działów,
   to widzę ludzi z podziałem i tylko zakładki które ci pisałem że mają być dodane". Serwer (GET /my-dept/scope → `dzialy[]`) podaje
   dla każdego działu jego rolę, kod trybu i listę zakładek — reguła J-5/N-6 bez zmian, tylko stosowana PER DZIAŁ. */

/** Zakładki działu z `/my-dept/scope`; `null` = komplet. Lista serwera ma pierwszeństwo, kod trybu jest zapasem. */
export const zakladkiDlaDzialu = (dzial) => {
    if (!dzial) return null;
    if (Array.isArray(dzial.zakladki)) return dzial.zakladki;
    const tryb = typeof dzial.trybZakladek === "string" ? dzial.trybZakladek : null;
    return dozwoloneZakladki(tryb === TRYB_ZAKLADEK.PELNY || tryb == null, tryb);
};

/** Suma zakładek kilku działów (widok „Wszystkie działy") w kolejności hubu; `null` = komplet albo brak działów. */
export const uniaZakladek = (dzialy) => {
    const lista = Array.isArray(dzialy) ? dzialy : [];
    if (lista.length === 0) return null;
    const ids = new Set();
    for (const dzial of lista) {
        const zakladki = zakladkiDlaDzialu(dzial);
        if (zakladki == null) return null;
        zakladki.forEach((id) => ids.add(id));
    }
    return MY_DEPT_TABS.map((t) => t.id).filter((id) => ids.has(id));
};
